<vi-panel main>
  <ng-container content>
    <vi-loader
      data-at-loader
      *ngIf="
        vddDetailsListStore.getIsVddWriting(
          parameter?.vddDetail?.name,
          parameter?.controlUnit?.value
        ) | async
      "
      [isLoading]="true"
    ></vi-loader>
    <mat-expansion-panel data-at-expansion-panel [expanded]="isPanelExpanded" hideToggle>
      <mat-expansion-panel-header>
        <div
          class="parameter-panel flex flex-row justify-between items-center flex-1"
          [class.low-opacity]="
            vddDetailsListStore.getIsVddWriting(
              parameter?.vddDetail?.name,
              parameter?.controlUnit?.value
            ) | async
          "
          [class.error]="dontDisplayVdd"
          (click)="stopPropagation($event)"
        >
          <div class="parameter-wrapper flex flex-row justify-center items-center">
            <mat-checkbox
              [(ngModel)]="parameter.isSelected"
              gtm="onSelect"
              gtmAction="Toggle selection of parameter {{ parameter.vddDetail.value }}"
              gtmCategory="diagnosticsPage"
              (ngModelChange)="updateParameter()"
            >
            </mat-checkbox>
            <div class="flex flex-col justify-center items-start">
              <span class="vdd-name"
                >{{ parameter.vddDetail.value | translate }}
                <mat-icon
                  class="info-icon"
                  matTooltip="{{ 'TI_' + parameter.vddDetail.name + '_Desc' | translate }}"
                  matTooltipPosition="above"
                >
                  info_outline
                </mat-icon>
              </span>
              <strong class="vdd-number"> {{ parameter?.vddDetail?.vddInterval }} </strong>
              <small>
                {{ parameter?.controlUnit?.objectProperty | translate }}
                {{ parameter?.controlUnit?.busType | translate }}:
                {{
                  remoteDiagnosticsMappers.getBusAddressOfLogicalLink(parameter?.controlUnit)
                }}</small
              >
            </div>
          </div>
          <div class="group-controller-wrapper flex flex-row flex-wrap justify-center items-center">
            <mat-spinner *ngIf="isVddLoading"></mat-spinner>
            <ng-container *ngIf="!isVddLoading">
              <div
                *ngIf="!dontDisplayVdd"
                class="toggle-panel flex flex-row justify-start items-center"
                (click)="togglePanel()"
              >
                <ng-container *ngIf="isPanelExpanded; else notExpanded">
                  <span>{{ 'DIAGNOSTICS.PARAMETER_ITEM.HIDE_VALUES' | translate }}</span>
                  <mat-icon>keyboard_arrow_up</mat-icon>
                </ng-container>
                <ng-template #notExpanded>
                  <span>{{ 'DIAGNOSTICS.PARAMETER_ITEM.SHOW_VALUES' | translate }}</span>
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </ng-template>
              </div>
              <vi-alert data-at-maintenance-notification *ngIf="dontDisplayVdd">
                <strong>{{ 'DIAGNOSTICS.VDD_CANNOT_BE_DISPLAYED' | translate }}</strong>
              </vi-alert>
            </ng-container>
          </div>
          <div class="buttons-wrapper flex flex-row justify-center items-center">
            <ng-container *ngIf="isVddRead">
              <mat-form-field
                class="timer-form-field"
                mat-select-height-medium
                mat-select-frameless
              >
                <div class="flex flex-row justify-center items-center">
                  <mat-icon>timer</mat-icon>
                  <mat-select
                    data-at-remote-diagnostics-parameter-interval-dropdown
                    fieldTextContentTooltip
                    gtm="onOpen"
                    gtmAction="Open interval dropdown for parameter '{{
                      parameter.vddDetail.value
                    }}'"
                    gtmCategory="diagnosticsPage"
                    [disabled]="isParameterRunning || dontDisplayVdd || isVddLoading"
                    [class.running-parameter]="isParameterRunning"
                    [(value)]="parameter.interval"
                    (selectionChange)="updateParameter()"
                  >
                    <mat-option
                      *ngFor="let interval of availableIntervals"
                      [value]="interval"
                      gtm="onSelect"
                      gtmAction="Set interval to selected parameter '{{
                        parameter.vddDetail.value
                      }}' value picked: '{{ interval }}'"
                      gtmCategory="diagnosticsPage"
                      fieldTextContentTooltip
                      >{{ interval | msToSeconds }}</mat-option
                    >
                  </mat-select>
                </div>
              </mat-form-field>
            </ng-container>
            <button
              data-at-save-value
              mat-icon-button
              [disabled]="
                !diagnosticsFormGroupService.isFormGroupValid() ||
                (vddDetailsListStore.isAnyVddWriting() | async) ||
                isParameterRunning ||
                dontDisplayVdd ||
                isVddLoading ||
                !isVddEditable
              "
              gtm="onSave"
              gtmAction="Write parameter '{{ parameter.vddDetail.value }}'"
              gtmCategory="diagnosticsPage"
              (click)="write()"
            >
              <mat-icon>save</mat-icon>
            </button>
            <ng-container *ngIf="isVddRead">
              <button
                data-at-play-button
                mat-icon-button
                [disabled]="
                  parametersWhichAreBeingRead.length >= 10 ||
                  isParameterRunning ||
                  dontDisplayVdd ||
                  isVddLoading
                "
                class="start-btn"
                gtm="onStart"
                gtmAction="Cycle read of parameter '{{ parameter.vddDetail.value }}'"
                gtmCategory="diagnosticsPage"
                (click)="start()"
              >
                <mat-icon>play_arrow</mat-icon>
              </button>
              <button
                data-at-stop-button
                mat-icon-button
                [disabled]="isParameterStopped || dontDisplayVdd || isVddLoading"
                gtm="onStop"
                gtmAction="Cycle read of parameter '{{ parameter.vddDetail.value }}'"
                gtmCategory="diagnosticsPage"
                (click)="stop()"
              >
                <mat-icon>stop</mat-icon>
              </button>
            </ng-container>
            <button
              data-at-remove-from-chart-button
              *ngIf="isVddSensor"
              mat-icon-button
              [disabled]="dontDisplayVdd || isVddLoading || !isParameterOnChart"
              gtm="onStop"
              gtmAction="Clear data of parameter '{{ parameter.vddDetail.value }}'"
              gtmCategory="diagnosticsPage"
              (click)="clear()"
            >
              <mat-icon>clear</mat-icon>
            </button>
            <button
              mat-icon-button
              class="delete-btn"
              gtm="onDelete"
              gtmAction="parameter '{{ parameter.vddDetail.value }}'"
              gtmCategory="diagnosticsPage"
              (click)="deleteParameter(parameter.id)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </mat-expansion-panel-header>
      <div class="group-controller-wrapper flex flex-row flex-wrap justify-start items-center">
        <app-diagnostics-default-template
          [vddName]="parameter.vddDetail.name"
          [logicalLink]="parameter.controlUnit.value"
          [diagnosticsFormGroupService]="diagnosticsFormGroupService"
          [parameterId]="parameter.id"
          [isVddEditable]="isVddEditable"
        ></app-diagnostics-default-template>
      </div>
    </mat-expansion-panel>
  </ng-container>
</vi-panel>
